import { Reducer } from 'redux';

import { ISetPlayer, IShuffle, TPlayer } from '../actions';
import { ContextEnum, PlayerStatus } from '../entities';

export type IPlayerState = PlayerStatus;
export const defaultPlayerState = {
  isDownloading: false,
  context: ContextEnum.timeSlot,
  media: {},
  state: 'PAUSE',
  volume: 0,
  event: {},
  favorite: {},
  muted: true,
  online: true,
  place: {},
  player: {},
  scheduleInWeeklyMode: true,
  shuffled: false,
  tempo: {},
  timeSlot: {},
  waitList: [],
  currentPosition: 0,
  playerContextType: 'SCHEDULE',
  location: 'scheduler',
};

export const playerReducer: Reducer<IPlayerState> = (
  state: IPlayerState = defaultPlayerState,
  action: ISetPlayer | IShuffle
): IPlayerState => {
  switch (action.type) {
    case TPlayer.SHUFFLE:
      state.shuffled = !state.shuffled;
      return state;
    case TPlayer.SET_PLAYER_STATUS:
      return action.payload;
    default:
      return state;
  }
};
